module.exports = __webpack_public_path__ + "static/media/Gallery18.328980ce.jpg";